import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { ProductGroupFragment } from '@occc/graphql';
import { productGroupKeysMap } from '@occc-app/routes/ProductGroup/constants';

interface IProductGroupDetails {
  productGroup: ProductGroupFragment;
}

export const ProductGroupDetails: React.FC<IProductGroupDetails> = ({ productGroup }) => {
  const { id, name, description, key, values } = productGroup;
  const keyLabel = `${productGroupKeysMap[key]}: `;

  return (
    <Box key={id}>
      <Typography variant='subtitle2' component='p'>
        {name}
      </Typography>
      <Typography variant='body2' gutterBottom>
        {description}
      </Typography>
      <Typography variant='body2' component='span'>
        {keyLabel}
      </Typography>
      <Typography variant='subtitle2' component='span'>
        {values.join(', ')}
      </Typography>
    </Box>
  );
};
